import { Component, Input } from '@angular/core';

@Component({
    selector: 'page-title',
    templateUrl: './page-title.component.html',
    styleUrl: './page-title.component.css',
})
export class PageTitleComponent {
    @Input() icon: string = 'cog';
    @Input() title: string = 'Page';
    @Input() description: string = 'Description';
}
